<template>
  <div :class="$style.container">
    <div :class="$style.group">
      <InputLabel text="Billing Options" />
      <ParagraphBody data-test-id="SubscriptionTypeReview__subType">
        {{ subscriptionType }} Billing
      </ParagraphBody>
    </div>
    <div
      v-if="isAnnual"
      :class="$style.group"
    >
      <InputLabel text="Total Users" />
      <ParagraphBody data-test-id="SubscriptionTypeReview__userCount">
        {{ userCount }}
      </ParagraphBody>
    </div>
  </div>
</template>

<script>
import { InputLabel, ParagraphBody } from '@jumpcloud/ui-components';
import { mapGetters } from 'vuex';

const pricingModule = 'PricingModule';

export default {
  name: 'SubscriptionTypeReview',

  components: {
    InputLabel,
    ParagraphBody,
  },

  computed: {
    ...mapGetters(pricingModule, {
      isAnnual: 'getIsAnnual',
      userCount: 'getUserCount',
    }),

    subscriptionType() {
      return this.isAnnual ? 'Annual' : 'Monthly';
    },
  },

  methods: {
    handleEdit() {
      this.$emit('edit');
    },
  },
};
</script>

<style module scoped>
.container {
  display: flex;
  width: 100%;
}

.group {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
}
</style>
